import React, { useEffect, useState } from "react";

import useLanguage from "../../hooks/useLanguage";
import useContent from "../../hooks/useContent";
import {
  Button,
  Divider,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import { LoginContainer, LoginFormWrapper, TitleWrapper } from "./styles";
import {
  notifyParentLoginSuccess,
  notifyParentLoginFailed,
} from "../../utils/notifyParent";

export default function Login({ setLogin }) {
  const [
    {
      pages: { login: t },
    },
  ] = useLanguage();
  const { login } = useContent();
  const [error, setError] = useState(null);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setError(null);
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const response = await login(form);
      if (response.error) {
        setError(response.error);
        // Ack the embedding parent that the manual login attempt failed.
        notifyParentLoginFailed("invalid_credentials");
      } else {
        localStorage.setItem("x-token", response.token);
        localStorage.setItem(
          "userdata",
          JSON.stringify({
            id: response.id,
            name: response.name,
            email: response.email,
            initials: response.name
              .split(" ")
              ?.map((n) => n[0])
              ?.join(""),
            nickname: response.name,
            color: "#4CAF50",
            role: response.role ?? "user",
            active: response.active ?? true,
            group: response.group ?? null,
          })
        );
        setLogin(true);
        // Ack the embedding parent (Reshet WP) that login completed.
        notifyParentLoginSuccess();
      }
    } catch (error) {
      setError(t.error);
      notifyParentLoginFailed("error");
    }
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Enter") {
        handleSubmit();
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [form]);

  return (
    <LoginContainer>
      <LoginFormWrapper>
        <TitleWrapper>
          <Typography variant="h4" component="h1" gutterBottom>
            {t.title}
          </Typography>
          <Typography variant="body2" gutterBottom>
            {t.subtitle}
          </Typography>
        </TitleWrapper>
        <Divider />
        <TextField
          label={t.email}
          name="email"
          type="email"
          fullWidth
          margin="normal"
          onChange={handleFormChange}
          error={!!error}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
            },
          }}
        />
        <TextField
          label={t.password}
          name="password"
          type="password"
          fullWidth
          margin="normal"
          onChange={handleFormChange}
          error={!!error}
          helperText={error}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
            },
          }}
        />
        <Button
          variant="contained"
          size="large"
          onClick={handleSubmit}
          fullWidth
        >
          {t.login}
        </Button>
      </LoginFormWrapper>
    </LoginContainer>
  );
}
